var _style, _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIndoorsLogo = function SvgIndoorsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.9 35",
    style: {
      enableBackground: "new 0 0 36.9 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#005E95;}\r\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Indoors")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,23.6V12.7l-2.5-1.1V6L19.2,0l-10,4.5C6.6,5.6,4.9,8.2,4.9,11v7.7l-1.5,0.8v4.3L0,25.5l6.7,3.4l4.9-2.3 C10,25.8,9,24.2,9,22.4V11c0-1.5,0.9-2.8,2.2-3.5l8.3-3.8L27.9,8v5.6l2,1v7.3c-0.1,2.1-0.4,3.1-4,4.9l-6.5,3.3l-3.6-1.6L11,30.8 l8.4,4.2l17.5-9.9L33.9,23.6z M23.3,17.5c0,2.2-1.7,3.9-3.9,3.9s-3.9-1.7-3.9-3.9s1.7-3.9,3.9-3.9l0,0 C21.5,13.6,23.3,15.4,23.3,17.5z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndoorsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indoors-logo.5aeaebed.svg";
export { ForwardRef as ReactComponent };